import React from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { FaUser, FaEdit, FaIdCard, FaEnvelope, FaPhone, FaMobileAlt } from 'react-icons/fa';

// Targeta de resum de dades del client; usada a OfertaDetail i ContratoDetail per mostrar la informació del titular
const ClientCard = ({ cliente, onEdit }) => {
    return (
        <Card className="h-100 border-0 shadow-sm rounded-4 overflow-hidden">
            <Card.Header className="bg-white border-bottom-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <FaUser className="me-2" />
                    Información del Cliente
                </div>
                {onEdit && (
                    <Button
                        variant="link"
                        className="p-0"
                        onClick={onEdit}
                        title="Editar Cliente"
                        aria-label="Editar información del cliente"
                    >
                        <FaEdit size={18} />
                    </Button>
                )}
            </Card.Header>
            <Card.Body>
                <Row className="g-4">
                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaUser className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Nombre Completo</label>
                                <p className="detail-card-value text-truncate" title={cliente.nombre} style={{ color: 'var(--ab-primary)' }}>{cliente.nombre || "No especificado"}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaIdCard className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">CIF / NIF</label>
                                <p className="detail-card-value">{cliente.vat || <span className="text-muted fst-italic">No especificado</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaEnvelope className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Email</label>
                                <p className="detail-card-value text-truncate" style={{ color: 'var(--ab-primary)' }} title={cliente.email}>{cliente.email || <span className="text-muted fst-italic">No especificado</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaPhone className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Teléfono</label>
                                <p className="detail-card-value">{cliente.phone || <span className="text-muted fst-italic">No especificado</span>}</p>
                            </div>
                        </div>
                    </Col>

                    {cliente.mobile && (
                        <Col md={6}>
                            <div className="d-flex align-items-center">
                                <FaMobileAlt className="detail-card-icon" />
                                <div>
                                    <label className="detail-card-label">Móvil</label>
                                    <p className="detail-card-value font-monospace">{cliente.mobile}</p>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>
            </Card.Body>
        </Card>
    );
};

export default ClientCard;
